document.addEventListener('click', function (event) {
  const swatch = event.target.closest('.tfc-card-swatch');

  if (!swatch) return;

  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  const image = card.querySelector('.card__media .media > img');
  const variantUrl = swatch.dataset.variantUrl;

  // Markeer de gekozen kleur
  card.querySelectorAll('.tfc-card-swatch').forEach(function (item) {
    item.classList.remove('is-selected');
  });

  swatch.classList.add('is-selected');

  // Wissel de productfoto als de variant een eigen afbeelding heeft
  if (image && swatch.dataset.image) {
    image.src = swatch.dataset.image;
    image.srcset = swatch.dataset.imageSrcset;
    image.alt = swatch.dataset.imageAlt || image.alt;
  }

  // Zorg dat de productlinks naar de gekozen variant verwijzen
  if (variantUrl) {
    card.querySelectorAll('.card__heading a').forEach(function (link) {
      link.href = variantUrl;
    });
  }
});